.root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--rec-color-header-bg);
  border-bottom: 1px solid var(--rec-color-border);
}

.item {
  display: flex;
  align-items: center;
}

.step {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 6px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
}

.step-state-active {
  background: var(--rec-color-btn-dark);
}

.num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 7px;
  background: var(--rec-color-border);
  color: var(--rec-color-muted);
  font-size: 8px;
  font-weight: 700;
}

.step-state-done .num {
  background: var(--rec-color-muted-fg);
  color: var(--rec-color-background);
}

.step-state-active .num {
  background: var(--rec-color-background);
  color: var(--rec-color-btn-dark);
}

.label {
  font-size: 10px;
  font-weight: 600;
  color: var(--rec-color-muted);
}

.step-state-done .label {
  color: var(--rec-color-muted-fg);
}

.step-state-active .label {
  color: var(--rec-color-background);
}

.sep {
  margin: 0 2px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
}

@media (max-width: 480px) {
  .root {
    padding: 8px 12px;
  }

  .step {
    gap: 0;
    padding: 3px 4px;
  }

  .step-state-active {
    gap: 5px;
    padding: 3px 6px;
  }

  .label {
    display: none;
  }

  .step-state-active .label {
    display: inline;
  }
}
